import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ArrowUp = ({ viewBox, stroke, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 10 10'}>
    <path d="M8 0L15.7942 6H0.205771L8 0Z" fill="#070A0D" />
  </BaseIcon>
);

export default ArrowUp;
